module.exports = __webpack_public_path__ + "static/media/home.0f03c5c7.jpg";